import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SubscriptionItemProps } from '../../../../store/subscription/types';
import { SubscriptionDetailProvider } from '../../contexts/SubscriptionDetail';
import { SubscriptionItemDetails } from '../SubscriptionItemDetails';

import { SubscriptionCardDesktop } from './Desktop';
import { SubscriptionCardMobile } from './Mobile';
import { SubscriptionCardTablet } from './Tablet';

export interface SubscriptionCardProps {
  subscription: SubscriptionItemProps;
  openDetails: () => void;
}

export const SubscriptionCard: React.FC<SubscriptionCardProps> = (props) => {
  const responsiveItem = useBreakpointValue({
    base: <SubscriptionCardMobile {...props} />,
    sm: <SubscriptionCardTablet {...props} />,
    lg: <SubscriptionCardDesktop {...props} />,
  });

  return (
    <SubscriptionDetailProvider>
      <SubscriptionItemDetails />
      {responsiveItem}
    </SubscriptionDetailProvider>
  );
};
